import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { HeadCodeInjector } from "@/components/HeadCodeInjector";

import Home from "@/pages/public/Home";
import About from "@/pages/public/About";
import Partners from "@/pages/public/Partners";
import Privacy from "@/pages/public/Privacy";
import Terms from "@/pages/public/Terms";
import CalendarPage from "@/pages/public/CalendarPage";
import ToursIndex from "@/pages/public/ToursIndex";
import TourDetail from "@/pages/public/TourDetail";
import Checkout from "@/pages/public/Checkout";
import Success from "@/pages/public/Success";
import BookingDetails from "@/pages/public/BookingDetails";
import PayPage from "@/pages/public/PayPage";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminTours from "@/pages/admin/AdminTours";
import AdminTourEdit from "@/pages/admin/AdminTourEdit";
import AdminCalendar from "@/pages/admin/AdminCalendar";
import AdminBookings from "@/pages/admin/AdminBookings";
import AdminCustomers from "@/pages/admin/AdminCustomers";
import AdminSubscribers from "@/pages/admin/AdminSubscribers";
import AdminBroadcasts from "@/pages/admin/AdminBroadcasts";
import AdminEmailTemplates from "@/pages/admin/AdminEmailTemplates";
import AdminStats from "@/pages/admin/AdminStats";
import AdminBookkeeping from "@/pages/admin/AdminBookkeeping";
import AdminGiftCards from "@/pages/admin/AdminGiftCards";
import AdminWaitlist from "@/pages/admin/AdminWaitlist";
import AdminScheduleRules from "@/pages/admin/AdminScheduleRules";
import AdminRestaurantNotifications from "@/pages/admin/AdminRestaurantNotifications";
import GiftCards from "@/pages/public/GiftCards";
import GiftCardSuccess from "@/pages/public/GiftCardSuccess";
import WaitlistClaim from "@/pages/public/WaitlistClaim";
import AdminSettings from "@/pages/admin/AdminSettings";

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <HeadCodeInjector />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/dates" element={<CalendarPage />} />
            <Route path="/calendar" element={<CalendarPage />} />
            <Route path="/tours" element={<ToursIndex />} />
            <Route path="/tour/:slug" element={<TourDetail />} />
            <Route path="/checkout/:instanceId" element={<Checkout />} />
            <Route path="/booking/success" element={<Success />} />
            <Route path="/booking/:id" element={<BookingDetails />} />
            <Route path="/gift-cards" element={<GiftCards />} />
            <Route path="/gift-cards/success" element={<GiftCardSuccess />} />
            <Route path="/waitlist/:token" element={<WaitlistClaim />} />
            <Route path="/pay/:token" element={<PayPage />} />
            <Route path="/pay/:token/success" element={<PayPage />} />
            <Route path="/embed/dates" element={<CalendarPage embed />} />
            <Route path="/embed/calendar" element={<CalendarPage embed />} />

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="tours" element={<AdminTours />} />
              <Route path="tours/:id" element={<AdminTourEdit />} />
              <Route path="calendar" element={<AdminCalendar />} />
              <Route path="bookings" element={<AdminBookings />} />
              <Route path="customers" element={<AdminCustomers />} />
              <Route path="subscribers" element={<AdminSubscribers />} />
              <Route path="broadcasts" element={<AdminBroadcasts />} />
              <Route path="email-templates" element={<AdminEmailTemplates />} />
              <Route path="email-templates/:key" element={<AdminEmailTemplates />} />
              <Route path="stats" element={<AdminStats />} />
              <Route path="bookkeeping" element={<AdminBookkeeping />} />
              <Route path="gift-cards" element={<AdminGiftCards />} />
              <Route path="waitlist" element={<AdminWaitlist />} />
              <Route path="schedule-rules" element={<AdminScheduleRules />} />
              <Route path="restaurant-notifications" element={<AdminRestaurantNotifications />} />
              <Route path="settings" element={<AdminSettings />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </div>
    </AuthProvider>
  );
}

export default App;
